import React from "react";
import MediaUpload from "./MediaUpload";

const inputClass =
  "w-full text-xs md:text-sm p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";

export default function MessageContentSection({
  idPrefix = "promo",
  message,
  onMessageChange,
  onMessageBlur,
  selectedImage,
  imagePreview,
  onImageChange,
  onRemoveImage,
  selectedVideo,
  videoPreview,
  onVideoChange,
  onRemoveVideo,
  url,
  onUrlChange,
  onUrlBlur,
}) {
  return (
    <div className="space-y-4 min-w-0">
      <div>
        <label
          htmlFor={`${idPrefix}-message`}
          className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
          Message *
        </label>
        <textarea
          id={`${idPrefix}-message`}
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          onBlur={onMessageBlur}
          rows={6}
          className={inputClass}
          placeholder="Enter your promotional message here..."
        />
        <p className="text-xs text-gray-500 mt-1">
          At least one content type (message, image, video, or URL) is required
        </p>
      </div>

      <div>
        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
          Image (Optional)
        </label>
        <MediaUpload
          type="image"
          inputId={`${idPrefix}-image-upload`}
          accept="image/*"
          hint="PNG, JPG, GIF up to 5MB"
          uploadLabel="Upload an image"
          onSelect={onImageChange}
          onRemove={onRemoveImage}
          preview={imagePreview}
        />
      </div>

      <div>
        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
          Video (Optional)
        </label>
        <MediaUpload
          type="video"
          inputId={`${idPrefix}-video-upload`}
          accept="video/*"
          hint="MP4, MOV, AVI up to 50MB"
          uploadLabel="Upload a video"
          onSelect={onVideoChange}
          onRemove={onRemoveVideo}
          preview={videoPreview}
        />
      </div>

      <div>
        <label
          htmlFor={`${idPrefix}-url`}
          className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
          URL / Link (Optional)
        </label>
        <input
          id={`${idPrefix}-url`}
          type="url"
          value={url}
          onChange={(e) => onUrlChange(e.target.value)}
          onBlur={onUrlBlur}
          className={inputClass}
          placeholder="https://example.com"
        />
        <p className="text-xs text-gray-500 mt-1">
          Enter a URL to share with the message
        </p>
      </div>
    </div>
  );
}
